import * as Styles from './styles'

const PreviewCanvas = ({ children }) => {
  return <Styles.Container data-testid="previewCanvas">{children}</Styles.Container>
}

export default PreviewCanvas
